import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import TokenService from "../Services/Token.service";

const LAST_ACTIVITY_KEY = "last_active_time";

export default function useSessionTimeout(onTimeout, timeoutMinutes = 10) {
  const location = useLocation();
  const timeoutMS = timeoutMinutes * 60 * 1000;

  useEffect(() => {
    const publicRoutes = [
      "/login",
      "/register",
      "/otp",
      "/forgot-password",
      "/session-timeout"
    ];

    const isPublic = publicRoutes.some(p =>
      location.pathname.toLowerCase().startsWith(p)
    );
    const isLoggedIn = !!TokenService.getUser();

    if (!isLoggedIn || isPublic) return;

    const updateActivity = () => {
      localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());
    };

    const checkTimeout = () => {
      const lastActive = parseInt(localStorage.getItem(LAST_ACTIVITY_KEY), 10);
      const idleTime = Date.now() - lastActive;

      if (idleTime > timeoutMS) {
        onTimeout(); //  all tabs idle
      }
    };

    // Initialize last activity on load
    if (!localStorage.getItem(LAST_ACTIVITY_KEY)) {
      updateActivity();
    }

    const events = ["mousemove", "click", "keypress", "scroll"];
    events.forEach(e => window.addEventListener(e, updateActivity));

    const checkInterval = setInterval(checkTimeout, 2000);

    return () => {
      events.forEach(e => window.removeEventListener(e, updateActivity));
      clearInterval(checkInterval);
    };
  }, [location.pathname, onTimeout]);
}
